/**
 * Password API Module
 * Методы для управления паролями: смена, сброс, подтверждение
 * 
 * @typedef {import('./types').ChangePasswordRequest} ChangePasswordRequest
 * @typedef {import('./types').ChangePasswordResponse} ChangePasswordResponse
 * @typedef {import('./types').ResetPasswordRequest} ResetPasswordRequest
 * @typedef {import('./types').ResetPasswordResponse} ResetPasswordResponse
 * @typedef {import('./types').ConfirmResetPasswordRequest} ConfirmResetPasswordRequest
 * @typedef {import('./types').ConfirmResetPasswordResponse} ConfirmResetPasswordResponse
 */

import { authFetch } from '../authClient';

/**
 * PUT /api/auth/users/me/password
 * Смена пароля текущего пользователя
 * @param {ChangePasswordRequest} data
 * @returns {Promise<ChangePasswordResponse>}
 */
export async function changePassword(data) {
  return authFetch('/api/auth/users/me/password', {
    method: 'PUT',
    body: JSON.stringify(data),
  });
}

/**
 * POST /api/auth/password-reset/request
 * Запрос на сброс пароля (отправляет письмо)
 * @param {ResetPasswordRequest} data
 * @returns {Promise<ResetPasswordResponse>}
 */
export async function requestPasswordReset(data) {
  return authFetch('/api/auth/password-reset/request', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

/**
 * POST /api/auth/password-reset/confirm
 * Подтверждение сброса пароля по токену
 * @param {ConfirmResetPasswordRequest} data
 * @returns {Promise<ConfirmResetPasswordResponse>}
 */
export async function confirmPasswordReset(data) {
  return authFetch('/api/auth/password-reset/confirm', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}
